import { buildQueryString } from '../../shared/actions/http';
import store from '../store';

export const remote = {
  fetchAll(params) {
    const config = store.get('config');
    const qs = buildQueryString(Object.assign({ siteId: config.siteId }, params));

    return fetch(`${config.baseUrl}/listProducts?${qs}`)
      .then(res => res.json())
      .then(result => addLocalProducts(result.data));
  },

  fetchByIds(productIds) {
    const config = store.get('config');
    const qs = buildQueryString({ siteId: config.siteId, productIds: productIds.join(',') });

    return fetch(`${config.baseUrl}/listProducts?${qs}`)
      .then(res => res.json())
      .then(result => addLocalProducts(result.data));
  }
};

/**
 * Add fetched products to local store
 */
export function addLocalProducts(products) {
  const localProducts = store.get('local.products');

  products.forEach(product => {
    const localIndex = localProducts.findIndex(lp => lp.id == product.id);
    const hasProduct = localIndex !== -1;

    if (hasProduct) {
      // Replace existing product
      localProducts[localIndex] = product;
    } else {
      // Add new item to array
      localProducts.push(product);
    }
  });

  store.set('local.products', localProducts);

  return products;
}

/**
 * Get local products by ids
 */
export function getLocalProductsByIds(productIds) {
  const localProducts = store.get('local.products')
    .filter(product => productIds.includes(product.id));

  return localProducts;
}
